import Proxy from '../Proxy';

class ContactProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('contacts', parameters);
  }

  createDiscount(contactId, data) {
    return this.submit('post', `${this.endpoint}/${contactId}/discounts`, data);
  }

  updateDiscount(contactId, data) {
    return this.submit('put', `${this.endpoint}/${contactId}/discounts/${data.id}`, data);
  }

  deleteDiscount(contactId, data) {
    return this.submit('delete', `${this.endpoint}/${contactId}/discounts/${data.id}`);
  }

  orderDiscount(contactId, data) {
    return this.submit('put', `${this.endpoint}/${contactId}/discounts-order`, data);
  }
}

export default ContactProxy;
